var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { Box, ModalDialog, ModalDialogCloseButton, ModalDialogContent, useScreenClass, tokens, ModalDialogTitle, } from '@vp/swan';
const modalContentStyles = css `
    && {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: ${tokens.SwanSemSpace5};
        gap: ${tokens.SwanSemSpace5};

        @media ${(_a = tokens.SwanSemMqGtXs) === null || _a === void 0 ? void 0 : _a.replace(/'/gi, '')} {
            padding: ${tokens.SwanSemSpace10};
            gap: ${tokens.SwanSemSpace5};
            max-height: 95vh;
            width: 600px;
        }
    }
`;
const closeButtonContainerStyles = css `
    && {
        position: absolute;
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        z-index: ${tokens.SwanSemZIndexOverTheTop};
        // on iOS browsers the z-index is flaky
        -webkit-transform: translateZ(1px);
    }
`;
export function StudioModal(props) {
    const { className, isOpen, onRequestDismiss, contentAriaLabel, closeButtonAccessibleText, modalTitle, children } = props, rest = __rest(props, ["className", "isOpen", "onRequestDismiss", "contentAriaLabel", "closeButtonAccessibleText", "modalTitle", "children"]);
    const screenClass = useScreenClass();
    return (_jsx(ModalDialog, Object.assign({ className: "modal", variant: screenClass === 'xs' ? 'panel-bottom' : 'standard', isOpen: isOpen, onRequestDismiss: onRequestDismiss }, rest, { children: _jsxs(ModalDialogContent, Object.assign({ "aria-labelledby": contentAriaLabel, className: modalContentStyles, fontSkin: "body-standard" }, { children: [!modalTitle && (_jsx(Box, Object.assign({ className: closeButtonContainerStyles }, { children: _jsx(ModalDialogCloseButton, { accessibleText: closeButtonAccessibleText }) }))), _jsxs(Box, { children: [_jsx(ModalDialogCloseButton, { accessibleText: closeButtonAccessibleText }), _jsx(ModalDialogTitle, { children: modalTitle })] }), children] })) })));
}
//# sourceMappingURL=StudioModal.js.map